import template from './payroll-details.html';
import controller from './payroll-details.controller';

let payrollDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default payrollDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll-details/payroll-details.component.js